/** Kiểm tra nhất quán B1→B5: gom dữ liệu các bước (đọc bằng quyền người dùng) và đánh dấu bước vừa thay đổi. */
import { b1AdvantageAdapter, b2StrategyAdapter } from './adapters/knowledgeSteps';
import { b4ThemeMapAdapter, b5FishboneAdapter } from './adapters/graphSteps';
import { loadKnowledge, itemsAt } from './adapters/knowledgeAdapter';

const STEP_ORDER = ['b1', 'b2', 'b3', 'b4', 'b5'];
const STORAGE_KEY = 'aiStepChanged';

export const markStepChanged = (step: string) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ step, at: Date.now() }));
  } catch {
    /* storage unavailable */
  }
};

/** Bước trước đó vừa đổi (trong 7 ngày) so với bước đang xem → nhắc kiểm tra nhất quán. */
export const upstreamChange = (step: string): { step: string; at: number } | null => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const v = JSON.parse(raw) as { step: string; at: number };
    const fresh = Date.now() - v.at < 7 * 24 * 3600 * 1000;
    return fresh && STEP_ORDER.indexOf(v.step) < STEP_ORDER.indexOf(step) ? v : null;
  } catch {
    return null;
  }
};

const safe = async <T,>(fn: () => Promise<T>): Promise<T | null> => {
  try {
    return await fn();
  } catch {
    return null;
  }
};

export const gatherPlan = async (): Promise<Record<string, unknown>> => {
  const [b1, strategy, theme, fish] = await Promise.all([
    safe(() => b1AdvantageAdapter.load()),
    safe(() => b2StrategyAdapter.load()),
    safe(() => b4ThemeMapAdapter.load()),
    safe(() => b5FishboneAdapter.load()),
  ]);
  const swotData = await safe(() => loadKnowledge('buoc2swot', [2, 11, 12, 13]));
  const plan: Record<string, unknown> = {};
  if (b1) plan.b1 = { strengths: itemsAt(b1, 2), csf: itemsAt(b1, 3), advantage: itemsAt(b1, 6) };
  if (strategy) {
    const snap = b2StrategyAdapter.buildSnapshot(strategy) as { sections: Record<string, { id: string; text: string; left_ids?: string[]; right_ids?: string[] }[]> };
    const chon = new Set(strategy.items.filter((i) => i.chon).map((i) => i.id));
    plan.b2 = {
      swot: swotData ? { strengths: itemsAt(swotData, 2), weaknesses: itemsAt(swotData, 11), opportunities: itemsAt(swotData, 12), threats: itemsAt(swotData, 13) } : {},
      strategies: Object.entries(snap.sections).flatMap(([section, list]) => list.map((s) => ({ ...s, section, chon: chon.has(s.id) }))),
    };
  }
  if (theme) plan.b4 = b4ThemeMapAdapter.buildSnapshot(theme);
  if (fish) plan.b5 = b5FishboneAdapter.buildSnapshot(fish);
  return plan;
};
